/** Build a DOM Node for a MapLibre feature popup, rendering all property
 *  values as TEXT (never raw HTML). MapLibre's built-in Popup accepts a
 *  Node — passing one we built with textContent guarantees no
 *  raw-HTML pathway exists. */

export const MAX_VALUE_LEN = 500;

export function buildFeaturePopupNode(
  properties: Record<string, any> | null,
): HTMLElement {
  const root = document.createElement('div');
  root.className = 'gis-feature-popup';
  // Inline styles win over inherited Tailwind/prose colors that would
  // otherwise leak `color: white` into the popup body — observed as
  // "white-on-white invisible text" inside chat-bubble dark-mode trees.
  root.style.color = '#1f2937';
  root.style.background = '#ffffff';
  root.style.padding = '4px 6px';
  root.style.fontSize = '12px';
  root.style.lineHeight = '1.4';
  root.style.minWidth = '120px';
  root.style.maxWidth = '320px';

  if (!properties || Object.keys(properties).length === 0) {
    root.textContent = 'No properties';
    return root;
  }

  const list = document.createElement('dl');
  list.style.margin = '0';
  list.style.color = '#1f2937';
  for (const [key, value] of Object.entries(properties)) {
    const dt = document.createElement('dt');
    dt.textContent = String(key);
    dt.style.fontWeight = '600';
    dt.style.color = '#4b5563';
    dt.style.fontSize = '11px';
    dt.style.textTransform = 'uppercase';
    dt.style.letterSpacing = '0.02em';
    dt.style.marginTop = '4px';
    list.appendChild(dt);

    const dd = document.createElement('dd');
    dd.style.margin = '0 0 4px 0';
    dd.style.color = '#1f2937';
    let valueText = value === null || value === undefined ? '' : String(value);
    if (valueText.length > MAX_VALUE_LEN) {
      valueText = valueText.slice(0, MAX_VALUE_LEN) + ' […]';
    }
    dd.textContent = valueText;
    list.appendChild(dd);
  }
  root.appendChild(list);
  return root;
}
